import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {StatusMessage} from '../../../graphql/common.datatypes';

export interface AddCreditCardAdjustmentInput {
    id: number
    amount: number
    payment_id: number | null
}

interface AddCreditCardAdjustmentData {
    __typename?: string,
    addCreditCardAdjustment: StatusMessage
}

export const ADD_CREDIT_CARD_ADJUETMENT_MUTATION = gql`
    mutation addCreditCardAdjustment($id: Int!, $amount: Float!, $payment_id: Int) {
        addCreditCardAdjustment(id: $id, amount: $amount, payment_id: $payment_id) {
            status
            message
        }
    }
`;

export const addCreditCardAdjustment = () => useMutation<AddCreditCardAdjustmentData, AddCreditCardAdjustmentInput>(
    ADD_CREDIT_CARD_ADJUETMENT_MUTATION,
    {
        //update: updateCacheByType('BillingParty'),
    }
);

export default addCreditCardAdjustment;
